import React, { useMemo } from 'react';
import { theme } from '../../../Theme';
import { ElevateCheckbox } from './ElevateCheckbox';

export const SizeFacet = ({ clickCallback, ...props }) => {
  //   const { handleFacetClick } = useFacetHandler([]);

  // Helper function to determine size category based on the label
  const categorizeSizeValue = value => {
    const label = value?.label || '';
    const numericValue = parseFloat(label.split('/')[0]); // Get first number for range sizes

    // UK/US sizes (typically 3-13 with half sizes)
    if (numericValue >= 3 && numericValue <= 13.5 && label.includes('.5')) {
      return 'UK/US';
    }
    if (numericValue >= 3 && numericValue <= 13 && !label.includes('/')) {
      return 'UK/US';
    }

    // EUR sizes (16+) - includes both single sizes and dual sizes
    if (numericValue >= 16) {
      return 'EUR';
    }

    // Other/Unknown
    return 'Övrigt';
  };

  // Flatten all size values and categorize them
  const flattenedAndCategorized = useMemo(() => {
    const allValues = [];

    props.sizeTypes?.forEach(sizeType => {
      sizeType.formats?.forEach(format => {
        format.values?.forEach(value => {
          if (value.count > 0) {
            const category = categorizeSizeValue(value);
            allValues.push({
              ...value,
              category,
              sizeTypeLabel: sizeType.label
            });
          }
        });
      });
    });

    // Group by category
    const grouped = allValues.reduce((acc, value) => {
      if (!acc[value.category]) {
        acc[value.category] = [];
      }
      acc[value.category].push(value);
      return acc;
    }, {});

    // Sort values within each category numerically
    Object.keys(grouped).forEach(category => {
      grouped[category].sort((a, b) => {
        const aNum = parseFloat(a.label.split('/')[0]);
        const bNum = parseFloat(b.label.split('/')[0]);
        return aNum - bNum;
      });
    });

    return grouped;
  }, [props.sizeTypes]);

  // Define order for categories
  const categoryOrder = ['EUR', 'UK/US', 'Övrigt'];

  // Category labels
  const categoryLabels = {
    EUR: 'EUR',
    'UK/US': 'UK/US',
    Övrigt: 'Övrigt'
  };

  return (
    <div>
      {categoryOrder.map(category => {
        const values = flattenedAndCategorized[category];
        if (!values || values.length === 0) return null;

        return (
          <div key={category} style={{ marginBottom: '1rem' }}>
            <h4
              style={{
                margin: '0.75rem 0 0.5rem 0',
                fontSize: '11px',
                fontWeight: 'bold',
                color: theme.colors.darkgrey,
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}
            >
              {categoryLabels[category]}
            </h4>
            <ul style={{ marginBottom: '0.5rem', background: '#f3f3f3' }}>
              {values.map(value => (
                <li key={`size-${value.id}`}>
                  <ElevateCheckbox
                    label={`${value.label}`}
                    count={value.count}
                    checked={value.selected}
                    onChange={() => clickCallback(value, props)}
                  />
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
};
